document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.hh-finder-section');
  if (!root) return;

  const panels = [...root.querySelectorAll('.hh-step-view')];
  const questionEl = root.querySelector('#hhCurrentQuestion');
  const backBtn = root.querySelector('#hhBackLink');
  
  const chipRoom = root.querySelector('#chipRoom');
  const chipStyle = root.querySelector('#chipStyle');
  const chipColor = root.querySelector('#chipColor');

  const loader = root.querySelector('#hhMatchLoader');
  const loaderTitle = root.querySelector('#loaderTitle');
  const loaderDesc = root.querySelector('#loaderDesc');
  const loaderFill = root.querySelector('#loaderFill');

  const stepQuestions = [
    'Halınızı nerede kullanacaksınız?',
    'Hangi tarz halı arıyorsunuz?',
    'Mobilyalarınıza hangi renk tonları eşlik etsin?'
  ];

  let currentStep = 0;
  const selectedValues = ['', '', ''];
  const selectedLabels = ['', '', ''];

  function updateChips() {
    if (selectedLabels[0]) {
      chipRoom.textContent = '🛋️ ' + selectedLabels[0];
      chipRoom.style.display = 'inline-flex';
    } else {
      chipRoom.style.display = 'none';
    }

    if (selectedLabels[1]) {
      chipStyle.textContent = '✨ ' + selectedLabels[1];
      chipStyle.style.display = 'inline-flex';
    } else {
      chipStyle.style.display = 'none';
    }

    if (selectedLabels[2]) {
      chipColor.textContent = '🎨 ' + selectedLabels[2];
      chipColor.style.display = 'inline-flex';
    } else {
      chipColor.style.display = 'none';
    }

    if (backBtn) {
      backBtn.style.display = currentStep > 0 ? 'inline-flex' : 'none';
    }
  }

  function setStep(idx) {
    currentStep = idx;
    panels.forEach((p, i) => {
      p.hidden = i !== currentStep;
    });

    if (questionEl) {
      questionEl.textContent = stepQuestions[currentStep] || stepQuestions[0];
    }

    updateChips();
  }

  panels.forEach((panel, stepIdx) => {
    panel.querySelectorAll('.hh-opt-card').forEach((btn) => {
      btn.addEventListener('click', () => {
        selectedValues[stepIdx] = btn.dataset.value || '';
        selectedLabels[stepIdx] = btn.dataset.label || btn.textContent.trim();

        panel.querySelectorAll('.hh-opt-card').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        updateChips();

        if (stepIdx < 2) {
          setTimeout(() => {
            setStep(stepIdx + 1);
          }, 150);
        } else {
          launchMatchingScreen();
        }
      });
    });
  });

  if (backBtn) {
    backBtn.addEventListener('click', () => {
      if (currentStep > 0) {
        selectedValues[currentStep] = '';
        selectedLabels[currentStep] = '';
        setStep(currentStep - 1);
      }
    });
  }

  function launchMatchingScreen() {
    panels.forEach(p => p.hidden = true);
    if (questionEl) questionEl.style.display = 'none';
    if (backBtn) backBtn.style.display = 'none';
    if (loader) loader.style.display = 'block';

    if (loaderFill) loaderFill.style.width = '35%';

    setTimeout(() => {
      const room = selectedLabels[0] || 'Eviniz';
      const style = selectedLabels[1] || 'Tüm Modeller';
      if (loaderTitle) loaderTitle.textContent = `${room} İçin En Uygun Halılar Bulundu!`;
      if (loaderDesc) loaderDesc.textContent = `${style} modelleri taranıyor (%98 Uyum)...`;
      if (loaderFill) loaderFill.style.width = '80%';
    }, 400);

    setTimeout(() => {
      if (loaderFill) loaderFill.style.width = '100%';
      const tags = selectedValues.filter(Boolean);
      const url = '/collections/all' + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '');
      window.location.assign(url);
    }, 1050);
  }

  setStep(0);
});